import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=e774b6d4&scoped=true"
import script from "./DetailSection.vue?vue&type=script&lang=js"
export * from "./DetailSection.vue?vue&type=script&lang=js"
import style0 from "./DetailSection.vue?vue&type=style&index=0&id=e774b6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e774b6d4",
  null
  
)

export default component.exports